module.exports = __webpack_public_path__ + "img/little.78779105.png";